// 本地存储工具函数

const STORAGE_KEY = 'eye_report_users';

// 获取所有用户
export const getUsersFromStorage = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : getDefaultUsers();
  } catch (error) {
    console.error('获取用户数据失败:', error);
    return getDefaultUsers();
  }
};

// 保存用户数据
export const saveUsersToStorage = (users) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(users));
  } catch (error) {
    console.error('保存用户数据失败:', error);
  }
};

// 添加新用户
export const addUser = (userData) => {
  const users = getUsersFromStorage();
  const newUser = {
    id: Date.now(),
    name: userData.name,
    school: userData.school || '新绑定学校',
    gender: Math.random() > 0.5 ? 'male' : 'female',
    reports: [
      { date: '2025年10月', fullDate: '2025-10-15' }
    ],
    ...userData
  };
  users.push(newUser);
  saveUsersToStorage(users);
  return newUser;
};

// 删除用户
export const removeUser = (userId) => {
  const users = getUsersFromStorage();
  const filteredUsers = users.filter(u => u.id !== userId);
  saveUsersToStorage(filteredUsers);
  return filteredUsers;
};

// 根据ID获取用户
export const getUserById = (userId) => {
  const users = getUsersFromStorage();
  return users.find(u => u.id === parseInt(userId));
};

// 默认用户数据
const getDefaultUsers = () => [
  {
    id: 1,
    name: '金欣雨',
    school: '温州高铁新城实验学校',
    gender: 'female',
    reports: [
      { date: '2025年10月', fullDate: '2025-10-23' },
      { date: '2025年9月', fullDate: '2025-09-15' },
      { date: '2025年8月', fullDate: '2025-08-09' },
    ]
  },
  {
    id: 2,
    name: '赖昌亿',
    school: '泰顺县职业教育中心',
    gender: 'male',
    reports: [
      { date: '2025年10月', fullDate: '2025-10-20' },
      { date: '2025年9月', fullDate: '2025-09-10' },
    ]
  },
  {
    id: 3,
    name: '郑帅',
    school: '苍南县灵溪���学·三禾高中',
    gender: 'male',
    reports: [
      { date: '2025年10月', fullDate: '2025-10-23' },
    ]
  },
  {
    id: 4,
    name: '兰瑞横',
    school: '苍南县灵溪第二高级中学',
    gender: 'male',
    reports: [
      { date: '2025年10月', fullDate: '2025-10-18' },
      { date: '2025年9月', fullDate: '2025-09-12' },
    ]
  }
];
